import { render, staticRenderFns } from "./AppGallery.vue?vue&type=template&id=4db79d44&scoped=true&"
import script from "./AppGallery.vue?vue&type=script&lang=js&"
export * from "./AppGallery.vue?vue&type=script&lang=js&"
import style0 from "./AppGallery.vue?vue&type=style&index=0&id=4db79d44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db79d44",
  null
  
)

export default component.exports